import type { ExtranetHotelExperience } from 'app/typings/core/extranet/hotel/experiences';
import type { ExtranetHotelPack } from 'app/typings/core/extranet/hotel/packs';
import { ExtranetPackStatus } from 'app/typings/core/extranet/hotel/packs';

export const getMustHavePackNames = (
  experience: ExtranetHotelExperience | undefined,
  packsList: ExtranetHotelPack[]
): string[] => {
  if (!experience) {
    return [];
  }

  return packsList
    .filter(
      (pack) =>
        pack.status === ExtranetPackStatus.PUBLISHED &&
        pack.packExperiences.some(
          (pe) =>
            pe.experienceId === experience.id && pe.isIncluded && !pe.isOptional
        )
    )
    .map((pack) => pack.nameForHotel || pack.nameForUser);
};
